import { render } from "./patientindex.vue?vue&type=template&id=7f8375e0&scoped=true"
import script from "./patientindex.vue?vue&type=script&lang=js"
export * from "./patientindex.vue?vue&type=script&lang=js"

import "./patientindex.vue?vue&type=style&index=0&id=7f8375e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8375e0"]])

export default __exports__